import { render } from "./PackageInfo.vue?vue&type=template&id=21095d28"
const script = {}

import exportComponent from "/var/www/pd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__